'use strict';

let _imboxInitDone = false;

function initImboxReplacement() {
    if (_imboxInitDone) return true; // redan klart

    const root           = document.getElementById('imboxReplacement');
    const launcher       = document.getElementById('replacementLauncher');
    const launcherLabel  = document.getElementById('replacementLauncherLabel');
    const launcherButton = document.getElementById('replacementLauncherButton');
    const closeArrow     = document.getElementById('replacementModalCloseArrow');
    const closeRound     = document.getElementById('replacementModalCloseRound');

    if (!root || !(launcher || launcherLabel || launcherButton)) {
        return false; // finns inte än
    }

    const bindOpen = (el) => {
        if (!el) return;
        el.addEventListener('click', openImboxReplacementModal);
        el.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                openImboxReplacementModal();
            }
        });
    };

    bindOpen(launcher);
    bindOpen(launcherLabel);
    bindOpen(launcherButton);

    if (closeArrow) {
        closeArrow.addEventListener('click', closeImboxReplacementModal);
        closeArrow.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                closeImboxReplacementModal();
            }
        });
    }
    if (closeRound) {
        closeRound.addEventListener('click', closeImboxReplacementModal);
        closeRound.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                closeImboxReplacementModal();
            }
        });
    }

    _imboxInitDone = true;
    return true;
}

(function bootstrapImboxReplacement() {
    if (document.readyState !== 'loading') {
        if (initImboxReplacement()) return;
    } else {
        document.addEventListener('DOMContentLoaded', () => initImboxReplacement());
    }

    const mo = new MutationObserver(() => {
        if (initImboxReplacement()) mo.disconnect();
    });
    mo.observe(document.documentElement || document, { childList: true, subtree: true });
})();

function handleConsentState() {
    const c = window.Cookiebot && window.Cookiebot.consent;
    const replacement = document.getElementById('imboxReplacement');

    const hasAll = c && c.statistics && c.preferences && c.marketing;

    if (hasAll) {
        loadImBoxWidget(); // döljer ersättaren
    } else {
        if (replacement) {
            replacement.style.display = 'flex';
            replacement.classList.add('imbox-replacement--closed');

            replacement.classList.remove('imbox-replacement--animate-launcher');
            void replacement.offsetWidth;
            replacement.classList.add('imbox-replacement--animate-launcher');
            
            initImboxReplacement();
        }
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleConsentState);
} else {
    handleConsentState();
}

window.addEventListener('CookiebotOnConsentReady', handleConsentState);

function loadImBoxWidget() {
    if (document.getElementById('imbox-script')) return;
    window._sid = '2990';
    const se = document.createElement('script');
    se.id = 'imbox-script';
    se.type = 'text/javascript';
    se.async = true;
    se.src = 'https://files.imbox.io/app/dist/initWidget.js';
    document.body.appendChild(se);

    const replacement = document.getElementById('imboxReplacement');
    if (replacement) {
        replacement.style.display = 'none';
    }
}

function openImboxReplacementModal() {
    const replacement = document.getElementById('imboxReplacement');
    const modalBody = replacement?.querySelector('.imbox-replacement__modal-body');
    const closeRound = replacement?.querySelector('.imbox-replacement__close-round');

    if (!replacement || !modalBody || !closeRound) return;

    replacement.classList.add('imbox-replacement--open');
    replacement.classList.remove('imbox-replacement--closed');

    modalBody.classList.remove('imbox-replacement__modal-body--exit');
    closeRound.classList.remove('imbox-replacement__close-round--exit');

    void modalBody.offsetWidth;
    void closeRound.offsetWidth;

    modalBody.classList.add('imbox-replacement__modal-body--enter');
    closeRound.classList.add('imbox-replacement__close-round--enter');

    replacement.classList.remove('imbox-replacement--animate-modal');
    void replacement.offsetWidth;
    replacement.classList.add('imbox-replacement--animate-modal');

    const label = document.getElementById('replacementLauncherLabel');
    const button = document.getElementById('replacementLauncherButton');
    [label, button].forEach(el => {
        if (el) el.setAttribute('aria-expanded', 'true');
    });

    const modal = document.getElementById('replacementModal');
    if (modal) {
        modal.setAttribute('aria-hidden', 'false');
    }
}

function closeImboxReplacementModal(event) {
    event.stopPropagation();

    const replacement = document.getElementById('imboxReplacement');
    const modalBody = replacement?.querySelector('.imbox-replacement__modal-body');
    const closeRound = replacement?.querySelector('.imbox-replacement__close-round');

    if (!replacement || !modalBody || !closeRound) return;

    modalBody.classList.remove('imbox-replacement__modal-body--enter');
    closeRound.classList.remove('imbox-replacement__close-round--enter');

    modalBody.classList.add('imbox-replacement__modal-body--exit');
    closeRound.classList.add('imbox-replacement__close-round--exit');

    const onTransitionEnd = (e) => {
        if (e.propertyName === 'opacity') {
            modalBody.removeEventListener('transitionend', onTransitionEnd);

            replacement.classList.remove('imbox-replacement--open');
            replacement.classList.add('imbox-replacement--closed');

            modalBody.classList.remove('imbox-replacement__modal-body--exit');
            closeRound.classList.remove('imbox-replacement__close-round--exit');

            replacement.classList.remove('imbox-replacement--animate-launcher');
            void replacement.offsetWidth;
            replacement.classList.add('imbox-replacement--animate-launcher');

            const label = document.getElementById('replacementLauncherLabel');
            const button = document.getElementById('replacementLauncherButton');
            [label, button].forEach(el => {
                if (el) el.setAttribute('aria-expanded', 'false');
            });

            const modal = document.getElementById('replacementModal');
            if (modal) {
                modal.setAttribute('aria-hidden', 'true');
            }
        }
    };

    modalBody.addEventListener('transitionend', onTransitionEnd);
}
